/** Build goal selects the environment; the hostname selects its brand only. */
export function resolveSettings(goal: string | undefined, hostname: string) {
  const host = hostname.toLowerCase();
  const traderion = host.endsWith('.traderion.com');
  const vegas = host.endsWith('.vegasimulator.com');
  const assessmentHost =
    host === 'portfolio-assessment.traderion.com' ||
    host === 'portfolio-assessment.vegasimulator.com' ||
    (host.startsWith('assessment.') && host.endsWith('.amplifyapp.com'));

  if (assessmentHost && goal !== 'assessment') {
    throw new Error(
      'The assessment site requires an assessment frontend build.',
    );
  }
  if (!goal) {
    return {
      BASE_URL: '127.0.0.1:8000',
      API_URL: 'http://127.0.0.1:8000/api',
      SOCKET_URL: 'ws://127.0.0.1:8000/api',
      MEDIA_URL: 'http://127.0.0.1:8000',
      ENVIRONMENT: 'local',
      DOMAIN: '127.0.0.1',
      HOST: 'VEGASIMULATOR',
    };
  }
  if (!['production', 'stage', 'assessment'].includes(goal)) {
    throw new Error(`Unknown frontend environment: ${goal}`);
  }

  const environment =
    goal === 'production' ? 'prod' : goal === 'stage' ? 'stg' : 'assessment';
  // An Amplify branch URL has no brand suffix. Its build goal must still
  // select its own backend; a staging or assessment preview never uses prod.
  const brand =
    traderion || (!vegas && goal !== 'assessment')
      ? 'traderion.com'
      : 'vegasimulator.com';
  const base = `pm-${environment}.${brand}`;
  return {
    BASE_URL: base,
    API_URL: `https://${base}/api`,
    SOCKET_URL: `wss://${base}/api`,
    // Assessment uploads/readbacks stay in the fork. Copied prod media must
    // be mirrored explicitly before testing it; there is no prod fallback.
    MEDIA_URL:
      goal === 'assessment'
        ? `https://${base}/media`
        : goal === 'stage'
          ? 'https://pm.stage.api.s3.amazonaws.com/media'
          : 'https://pm.api.s3.amazonaws.com/media',
    ENVIRONMENT: environment,
    // Existing prod/stage SSO scope is unchanged. Assessment uses its own
    // cookie names and frontend host, including on the Amplify branch URL.
    DOMAIN:
      goal === 'assessment'
        ? host
        : traderion
          ? '.traderion.com'
          : vegas
            ? '.vegasimulator.com'
            : host,
    HOST: traderion ? 'TRADERION' : 'VEGASIMULATOR',
  };
}
